import script from "./VatRegistrationNumber.vue?vue&type=script&setup=true&lang=js"
export * from "./VatRegistrationNumber.vue?vue&type=script&setup=true&lang=js"

import "./VatRegistrationNumber.vue?vue&type=style&index=0&id=561fad96&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-561fad96"]])

export default __exports__